import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Link, Text } from '@bonusly/design-system';
import { Permission, useCurrentUser, usePermission } from '@bonusly/who-am-i';

import { useProfilePath } from '../../../profile/hooks/use-profile-path';
import { UserCard } from '../User';

export const NavMenuHeader: FC = () => {
	const user = useCurrentUser();
	const { t } = useTranslation('navigation');
	const canAccessUserProfile = usePermission(Permission.CanAccessUserProfile);
	const { isNewProfileEnabled, getProfilePath, getProfileUrl } = useProfilePath();

	if (!canAccessUserProfile) {
		return (
			<Box backgroundColor="transparent" listStyleType="none" p={2} mb={1} display="block" borderRadius="md">
				<UserCard user={user} />
			</Box>
		);
	}

	const linkStyles = {
		backgroundColor: 'transparent',
		listStyleType: 'none' as const,
		p: 2,
		mb: 1,
		transitionDuration: 'normal',
		transitionProperty: 'common',
		display: 'block',
		borderRadius: 'md',
		textDecoration: 'none',
		_focus: { backgroundColor: 'secondary.bgAlpha' },
		_hover: { backgroundColor: 'secondary.bgAlpha', textDecoration: 'none' },
	};

	const cardContent = (
		<UserCard
			description={
				<Text as="span" color="blue.600" fontSize="sm">
					{t('user_menu.view_profile')}
				</Text>
			}
			user={user}
		/>
	);

	if (isNewProfileEnabled) {
		return (
			<Link as={RouterLink} to={getProfilePath(user.id)} {...linkStyles}>
				{cardContent}
			</Link>
		);
	}

	return (
		<Link as="a" href={getProfileUrl(user.id)} {...linkStyles}>
			{cardContent}
		</Link>
	);
};
